export default __webpack_public_path__ + "static/50-sitzer-1-d1ca9b1474b111e3b09be4588800febd.jpg";